import { useMutation, UseMutationResult, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useAtom } from 'jotai';
import HttpStatusCode from './HttpStatusCode';
import { ErrorMessageAtom } from '@/utility/CommonAtoms';

export const useMutationWrapper = <TData = unknown, TError = unknown, TVariables = void, TContext = unknown>(
  options?: Omit<UseMutationOptions<TData, TError, TVariables, TContext>, 'onError'> & {
    getErrorMessage?: (httpStatus?: HttpStatusCode) => string;
  }
): UseMutationResult<TData, TError, TVariables, TContext> => {
  const [, setMessage] = useAtom(ErrorMessageAtom);
  setMessage('');
  return useMutation({
    ...options,
    onError: (error) => {
      if (error instanceof AxiosError) {
        const errorMessage = options?.getErrorMessage?.(error.response?.status);
        if (errorMessage) {
          setMessage(errorMessage);
        } else {
          setMessage('一時的なエラーが発生しました。お手数ですが、しばらく経ってからお試しください。');
          if (error.response?.data?.errors) {
            console.warn(error.response.data.errors);
          }
        }
      }
    }
  });
};
